import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { style: {"white-space":"pre-line"} }
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 2,
  class: "wage-insurance-single__fix-cb-spacer",
  "aria-hidden": "true"
}
const _hoisted_5 = ["id", "title"]
const _hoisted_6 = {
  key: 4,
  class: "wage-payroll-premium"
}
const _hoisted_7 = ["id", "value", "readonly", "tabindex", "onInput", "onBlur"]
const _hoisted_8 = ["id", "value", "title"]
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["id", "value", "onInput", "onBlur"]
const _hoisted_11 = ["id", "value", "onInput"]

import { computed, inject } from 'vue';
import {
  isHomeWagePayrollTotalKey,
  type HomeWagePayrollFieldDef,
  type HomeWagePayrollFieldKey,
  type HomeWagePremiumAmountKey,
  type HomeWagePremiumHoursKey,
} from '@/policies';
import HomeWageTooltip from '@/components/wage/home/HomeWageTooltip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWagePayrollFieldRows',
  props: {
    fields: {},
    gridClass: {},
    formatMoney: { type: Function },
    formatPremiumHours: { type: Function },
    textValue: { type: Function },
    getTooltip: { type: Function },
    hidePremiumHours: { type: Boolean },
    alignWithFixCheckbox: { type: Boolean },
    premiumHoursReadonly: { type: Boolean }
  },
  emits: ["money-input", "money-blur", "premium-hours-input", "premium-hours-blur", "text-input"],
  setup(__props: any, { emit: __emit }) {

const injectedShowTooltips = inject<{ value: boolean } | boolean>('showWageTooltips', true);
const showTooltips = computed(() => {
  if (typeof injectedShowTooltips === 'boolean') return injectedShowTooltips;
  if (injectedShowTooltips && typeof injectedShowTooltips === 'object' && 'value' in injectedShowTooltips) {
    return injectedShowTooltips.value;
  }
  return true;
});



const emit = __emit;

const isTotal = (field: HomeWagePayrollFieldDef) =>
  !!field.isTotal || isHomeWagePayrollTotalKey(field.key);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wage-payroll-grid", [
      __props.gridClass,
      { 'wage-payroll-grid--with-fix-cb': __props.alignWithFixCheckbox },
    ]])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: field.key
      }, [
        (showTooltips.value && (__props.getTooltip ? __props.getTooltip(field.key) : field.tooltip))
          ? (_openBlock(), _createBlock(HomeWageTooltip, {
              key: 0,
              location: "top"
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createElementVNode("label", _mergeProps({ ref_for: true }, tooltipProps, {
                  class: ["wage-payroll-grid__label wage-payroll-grid__label--tooltip", { 'wage-payroll-grid__label--total': isTotal(field) }],
                  for: field.premiumHours && field.hoursKey ? `payroll-hours-${field.hoursKey}` : `payroll-${field.key}`
                }), _toDisplayString(field.label), 17, _hoisted_1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.getTooltip ? __props.getTooltip(field.key) : field.tooltip), 1)
              ]),
              _: 2
            }, 1024))
          : (_openBlock(), _createElementBlock("label", {
              key: 1,
              class: _normalizeClass(["wage-payroll-grid__label", { 'wage-payroll-grid__label--total': isTotal(field) }]),
              for: field.premiumHours && field.hoursKey ? `payroll-hours-${field.hoursKey}` : `payroll-${field.key}`
            }, _toDisplayString(field.label), 11, _hoisted_3)),
        (__props.alignWithFixCheckbox)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : _createCommentVNode("", true),
        (field.premiumHours && __props.hidePremiumHours)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              id: `payroll-${field.key}`,
              class: "wage-payroll-grid__value wage-payroll-grid__value--premium-amount",
              title: `${field.label} (생산직 비과세 — 금액만 표시)`
            }, _toDisplayString(__props.formatMoney(field.key)), 9, _hoisted_5))
          : (field.premiumHours && field.hoursKey)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("input", {
                  id: `payroll-hours-${field.hoursKey}`,
                  type: "text",
                  class: _normalizeClass(["wage-payroll-premium__hours", { 'wage-payroll-premium__hours--readonly': __props.premiumHoursReadonly }]),
                  value: __props.formatPremiumHours(field.hoursKey),
                  placeholder: "시간",
                  inputmode: "decimal",
                  readonly: __props.premiumHoursReadonly,
                  tabindex: __props.premiumHoursReadonly ? -1 : undefined,
                  onInput: ($event: any) => (emit('premium-hours-input', field.hoursKey, $event)),
                  onBlur: ($event: any) => (emit('premium-hours-blur', field.hoursKey, field.key)),
                  onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (($event.target as HTMLInputElement).blur()), ["enter"]))
                }, null, 42, _hoisted_7),
                _createElementVNode("input", {
                  id: `payroll-${field.key}`,
                  type: "text",
                  class: "wage-payroll-premium__amount wage-payroll-grid__input wage-payroll-grid__input--readonly",
                  value: __props.formatMoney(field.key),
                  readonly: "",
                  tabindex: "-1",
                  title: `${field.label} (시간×시급 자동계산)`
                }, null, 8, _hoisted_8)
              ]))
            : (field.money && field.readonly)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 5,
                  id: `payroll-${field.key}`,
                  type: "text",
                  class: "wage-payroll-grid__input wage-payroll-grid__input--readonly",
                  value: __props.formatMoney(field.key),
                  readonly: "",
                  tabindex: "-1"
                }, null, 8, _hoisted_9))
              : (field.money)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 6,
                    id: `payroll-${field.key}`,
                    type: "text",
                    class: _normalizeClass(["wage-payroll-grid__input", {
          'wage-payroll-grid__input--linked': field.hourlyLinked,
          'wage-payroll-grid__input--total': isTotal(field),
        }]),
                    value: __props.formatMoney(field.key),
                    inputmode: "numeric",
                    onInput: ($event: any) => (emit('money-input', field.key, $event)),
                    onBlur: ($event: any) => (emit('money-blur', field.key)),
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (($event.target as HTMLInputElement).blur()), ["enter"]))
                  }, null, 42, _hoisted_10))
                : (_openBlock(), _createElementBlock("input", {
                    key: 7,
                    id: `payroll-${field.key}`,
                    value: __props.textValue(field.key),
                    type: "text",
                    class: "wage-payroll-grid__input",
                    onInput: ($event: any) => (emit('text-input', field.key, $event)),
                    onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (($event.target as HTMLInputElement).blur()), ["enter"]))
                  }, null, 40, _hoisted_11))
      ], 64))
    }), 128))
  ], 2))
}
}

})